export default function Coupang() {
	return <div className='Coupang'>Coupang</div>;
}
